import SettingComponent from "./Setting";

export const Setting = SettingComponent;
